var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronRightSm = function SvgChevronRightSm(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6275_87382)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.649594 0.170067C0.849052 -0.056689 1.17244 -0.056689 1.3719 0.170067L6.5 6L1.3719 11.8299C1.17244 12.0567 0.849052 12.0567 0.649594 11.8299C0.450135 11.6032 0.450135 11.2355 0.649594 11.0088L5.0554 6L0.649594 0.991223C0.450135 0.764467 0.450135 0.396823 0.649594 0.170067Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6275_87382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    fill: "white",
    transform: "translate(6.5 12) rotate(-180)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRightSm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chevron-right-sm.7b6e4fde88903b1124221ebd8ec5afd6.svg";